import {
    Grid,
    Typography,
    Tab,
    Tabs,
    Box,
    Paper,
    Card,
    Button,
    Avatar,
    TextField,
    Link
} from "@mui/material";
import { styled } from "@mui/system";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import RedButton from "../components/redButton";

import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { Container } from "@mui/system";
import PropTypes from "prop-types";
import React from "react";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import globals from "../globals";
import { formatEur, formatLevaTooltip } from "../utils";
import EditNoteIcon from '@mui/icons-material/EditNote';
import ChatIcon from '@mui/icons-material/Chat';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useAuth } from "../context/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import Countdown from "../components/countdown"
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import LoadingIcon from "../components/loading";

const DashboardTextField = styled(TextField)(() => ({
    borderRadius: 3,
    // backgroundColor: globals.colors.lightPink, // default background
    // '&:hover': {
    //     backgroundColor: globals.colors.lightPink, // no color on hover
    // },
    '& .MuiOutlinedInput-root': {
        '& .MuiInputBase-input': {
            backgroundColor: globals.colors.lightPink,
        },
        '& fieldset': {
            borderColor: 'transparent', // no border by default
        },
        '&:hover fieldset': {
            borderColor: 'transparent', // no border on hover
        },
        '&.Mui-focused fieldset': {
            borderColor: globals.colors.lightRed, // red border when typing
        },
    },
}));



const cartCourses = [
    {
        id: 1,
        title: "Course 1",
        instructor: "Instructor Name",
        price: 100,
        day: "Вторник",
        date: "16.05.2023",
        startTime: "10:00",
        endTime: "11:00",
        status: "Успешно",
        num: 1,
    },
    {
        id: 2,
        title: "Course 2",
        instructor: "Instructor Name",
        price: 150,
        day: "Понеделник",
        date: "18.06.2025",
        startTime: "10:00",
        endTime: "11:00",
        status: "Неуспешно",
        num: 4,
    },
    {
        id: 3,
        title: "Course 3",
        instructor: "Instructor Name",
        price: 100,
        day: "Сряда",
        date: "01.01.2024",
        startTime: "14:00",
        endTime: "15:00",
        status: "Успешно",
        num: 5,
    },
    {
        id: 4,
        title: "Course 4",
        instructor: "Instructor Name",
        price: 100,
        day: "Четвъртък",
        date: "22.02.2024",
        startTime: "10:00",
        endTime: "11:00",
        status: "Неуспешно",
        num: 2,
    }
]

const CALENDAR_HEIGHT = 48;
const CALENDAR_PADDIONG_TOP = 8;

const CalendarProps = {
    PaperProps: {
        style: {
            maxHeight: CALENDAR_HEIGHT * 4.5 + CALENDAR_PADDIONG_TOP,
            width: 250,
        },
    },
};

// Dialog for delete a course
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// For Calendar with hours
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};


const StudentDashboard = ({ isInstructor }) => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { user, token } = useAuth();

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') ? parseInt(searchParams.get('tab')) : 0);
    const [calendar, setCalendar] = React.useState([]);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [personName, setPersonName] = React.useState(0);
    const [avatar, setAvatar] = React.useState((user) ? user.image_url : 0);
    const [avatarFile, setAvatarFile] = React.useState(null);
    const [courses, setCourses] = React.useState([]);
    const [chats, setChats] = React.useState([]);
    const [dashboardLoading, setDashboardLoading] = React.useState(true);
    const [payments, setPayments] = React.useState([]);
    const [nextMeeting, setNextMeeting] = React.useState(null);
    const [notifications, setNotifications] = React.useState([]);

    // Changing password
    const [password, setPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");
    const [error, setError] = React.useState("");

    useEffect(() => {
        fetch(globals.apiUrl + '/courses/my-dashboard', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                console.log({data})
                setCourses(data.courses);
                setChats(data.chats);
                setPayments(data.payments);
                setNextMeeting(data.next_meeting);
                setNotifications(data.notifications);
                setDashboardLoading(false);
            })
            .catch(error => {
                //console.log(error);
            });

        // fetch(globals.apiUrl + '/courses/chats/', {
        //     method: 'GET',
        //     headers: {
        //         'Authorization': `Bearer ${token}`
        //     }
        // })
        // .then(response => response.json())
        // .then(data => {
        //     console.log('chats', data);
        //     setChats(data);
        // })
        // .catch(error => {
        //     console.log('error', error);
        // });
    }, [token]);

    //console.log(avatar);

    const [userData, setUserData] = React.useState({
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        phone_number: user.phone_number,
        password: "",
        description: user.description,
    });

    const handleUserDataChange = (event) => {
        setUserData({
            ...userData,
            [event.target.id]: event.target.value
        });
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setSearchParams({ tab: newValue });
    };

    // Handler that updates state for a specific day
    const handleCalendarChange = (day) => (event) => {
        const { value } = event.target;
        setCalendar((prev) => ({
            ...prev,
            [day]: typeof value === "string" ? value.split(",") : value,
        }));
    };

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const handleChangeStudent = (courseKey) => (event) => {
        const value = event.target.value;
        setPersonName((prev) => ({
            ...prev,
            [courseKey]: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setAvatar(URL.createObjectURL(file));
            setAvatarFile(file);
        }
    };

    const handleSaveChanges = (e) => {
        e.preventDefault();
        //console.log(userData);
        //console.log(token);

        const data = {
            first_name: userData.first_name,
            last_name: userData.last_name,
            email: userData.email,
            phone_number: userData.phone_number,
            description: userData.description,
        }
        if (userData.password.length > 0 && userData.password === confirmPassword) {
            data.password = userData.password;
        }
        //console.log(data);

        const formData = new FormData();
        formData.append("data", JSON.stringify(data));
        if (avatarFile) {
            formData.append("file", avatarFile);
        }
        formData.append("image_url", null);

        fetch(globals.apiUrl + "/auth/me", {
            method: "PUT",
            body: formData,
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        })
            .then(response => response.json())
            .then(response => {
                //console.log(response);
                if (response.detail) {
                    // setError(response.detail);
                    //console.log(response.detail);
                }
                else {
                    navigate(0);
                }
            })
            .catch(error => {
                //console.log(error);
            });
    }

    return (
        <Container>
            {(nextMeeting && JSON.stringify(nextMeeting) != '{}') &&
                <a href='/upcoming-meetings' style={{ textDecoration: 'none' }}>
                    <Grid container direction={'column'} >
                        <Paper sx={{ backgroundColor: globals.colors.lightBlue, p: 1 }}>
                            <Grid item>
                                <Typography sx={{ fontSize: 18, fontWeight: 'bold', color: globals.colors.backgroundColor }}>
                                    <AccessAlarmIcon sx={{ mb: -0.7, mr: 1 }} />Следващият ти урок започва след: <Countdown targetDate={nextMeeting.from_time} /></Typography>
                            </Grid>
                        </Paper>
                    </Grid>
                </a>}
            <Typography sx={{ mb: 2, color: globals.colors.darkBlue, fontSize: 25, fontWeight: 'bold', mt: 3 }}>Моят профил</Typography>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={8}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs example"
                        sx={{
                            border: 1, borderColor: "divider", border: 1,
                            borderColor: "divider",
                            "& .MuiTab-root": {
                                color: globals.colors.textColor,             // Unselected text color
                            },
                            "& .Mui-selected": {
                                color: globals.colors.lightRed, // Selected tab text color
                            },
                            "& .MuiTabs-indicator": {
                                backgroundColor: globals.colors.lightRed, // Underline color
                            },
                        }}
                        textColor={globals.colors.lightRed}
                    >
                        <Tab label="Курсове" sx={{ textTransform: "capitalize" }} value={0} />
                        <a href='/upcoming-meetings' style={{ textDecoration: 'none', color: globals.colors.textColor }}>
                            <Tab label="Срещи" href='/upcoming-meetings' sx={{ textTransform: "capitalize" }} disabled />
                        </a>
                        <Tab label="Разговори" sx={{ textTransform: "capitalize" }} value={1} />
                        <Tab label="Плащания" sx={{ textTransform: "none" }} value={2} />
                        <Tab label="За мен" sx={{ textTransform: "capitalize" }} value={3} />
                        <Tab label="Правила" sx={{ textTransform: "capitalize" }} value={4} />
                    </Tabs>

                    {/* Courses */}
                    <TabPanel value={tabValue} index={0}>
                        {dashboardLoading ?
                            <Grid container justifyContent={'center'}>
                                <Grid item>
                                    <LoadingIcon />
                                </Grid>
                            </Grid>
                            :
                            <Grid container spacing={3}>
                                {courses.length > 0 ? courses.map((course, index) => (
                                    <Grid item xs={12} sm={12} key={`course-${course.id}`}>
                                        <Paper elevation={5} sx={{
                                            backgroundColor: globals.colors.lightPink
                                        }}>
                                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                                <Grid item xs={12} sm={4}>
                                                    <img src={course.image_url} style={{ height: 140, width: 220 }} />
                                                </Grid>
                                                <Grid item xs={12} sm={8}>
                                                    <Link href={`/course/${course.id}`} sx={{ textDecoration: 'none', color: globals.colors.darkBlue }}>
                                                        <Typography sx={{ fontSize: 20, fontWeight: 'bold', mt: 2 }}>
                                                            {(course.title.length <= 38) ? course.title : course.title.slice(0, 35).concat('...')}
                                                        </Typography>
                                                    </Link>
                                                    <Typography>{course.instructor_name}</Typography>

                                                    <Grid container sx={{ mt: 3 }}>
                                                        <Grid item>
                                                            <Button variant='contained' href={`/course/${course.id}`} type='submit' size='large' sx={{
                                                                backgroundColor: globals.colors.lightRed, textTransform: 'none', '&:hover': {
                                                                    backgroundColor: globals.colors.darkRed,
                                                                },
                                                            }}> Към курса </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                ))
                                    :
                                    <Grid item>
                                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>За момента нямаш закупени курсове.</Typography>
                                        <Typography>Може да си избереш следващия си курс от <a href='/courses' style={{ color: globals.colors.lightRed, textDecoration: 'none', fontWeight: 'bold' }}>тук.</a></Typography>
                                    </Grid>
                                }
                            </Grid>
                        }
                    </TabPanel>


                    {/* Chat */}
                    <TabPanel value={tabValue} index={1}>
                        {dashboardLoading ?
                            <Grid container justifyContent={'center'}>
                                <Grid item>
                                    <LoadingIcon />
                                </Grid>
                            </Grid>
                            :
                            <Grid container direction={'column'}>

                                {chats.length > 0 ? chats.map((chat, index) => (
                                    <Paper sx={{ my: 1 }} elevation={4}>
                                        <Grid item sx={{ my: 2, ml: 2 }}>
                                            <Grid container sx={{ display: 'flex' }}>
                                                <Grid item>
                                                    <Avatar src={chat.instructor_image_url} sx={{ width: 60, height: 60 }} />
                                                </Grid>
                                                <Grid item>
                                                    <Typography sx={{ mx: 3, mt: 1 }}>{chat.instructor_name}</Typography>
                                                    <Typography sx={{ mx: 2.5, fontSize: 13 }}>{chat.course_title}</Typography>
                                                </Grid>
                                                <Grid item>
                                                    <IconButton sx={{ mt: 1, ml: 3, color: globals.colors.darkBlue }} href={`/chat/${chat.id}`}><ChatIcon /></IconButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                ))
                                    :
                                    <Grid item>
                                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>За момента нямаш създадени разговори.</Typography>
                                        {/* <Typography>Може да си избереш следващия си курс от <a href='/courses' style={{ color: globals.colors.lightRed, textDecoration: 'none', fontWeight: 'bold' }}>тук.</a></Typography> */}
                                    </Grid>
                                }
                            </Grid>
                        }
                    </TabPanel>

                    {/* Payment history */}
                    <TabPanel value={tabValue} index={2}>
                        {dashboardLoading ?
                            <Grid container justifyContent={'center'}>
                                <Grid item>
                                    <LoadingIcon />
                                </Grid>
                            </Grid>
                            :
                            <Grid container>
                                <Paper elevation={3} sx={{ backgroundColor: globals.colors.lightPink }}>
                                    <Grid>
                                        {payments.map((course) => (
                                            <Grid key={course.id} sx={{ padding: 2, borderBottom: '1px solid #ffff' }}>
                                                <Grid container alignItems="center" sx={{ mb: 1, mr: 2 }} justifyContent="center" spacing={5}>
                                                    {/* <Grid item sm={2} xs={4} textAlign={'center'}>
                                                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mb: 1 }}>Номер</Typography>
                                                    <Typography sx={{ color: globals.colors.gray, }}>{course.id}</Typography>
                                                </Grid> */}
                                                    <Grid item sm={2} xs={4} textAlign={'center'}>
                                                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mb: 1 }}>Дата</Typography>
                                                        <Typography sx={{ color: globals.colors.gray, }}>{course.created_at.split('T')[0]}</Typography>
                                                    </Grid>
                                                    <Grid item sm={2} xs={4} textAlign={'center'}>
                                                        <Typography noWrap sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mb: 1 }}>Курс</Typography>
                                                        <Typography sx={{ color: globals.colors.gray, }}>{course.course_title}</Typography>
                                                    </Grid>
                                                    <Grid item sm={2} xs={4} textAlign={'center'}>
                                                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mb: 1 }}>Учител</Typography>
                                                        <Typography sx={{ color: globals.colors.gray, }}>{course.instructor_name}</Typography>
                                                    </Grid>
                                                    <Grid item sm={2} xs={4} textAlign={'center'}>
                                                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mb: 1 }}>Брой</Typography>
                                                        <Typography sx={{ color: globals.colors.gray, }}>{course.amount}</Typography>
                                                    </Grid>
                                                    <Grid item sm={2} xs={4} textAlign={'center'}>
                                                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold', mb: 1 }}>Цена</Typography>
                                                        <Typography sx={{ color: globals.colors.gray, }} title={formatLevaTooltip(course.price * course.amount)}>{formatEur(course.price * course.amount)}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Paper>
                            </Grid>
                        }
                    </TabPanel>

                    {/* My dashboard */}
                    <TabPanel value={tabValue} index={3}>
                        <Grid container direction={'column'}>
                            <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, mb: 3, fontWeight: 'bold' }}>Профилна снимка</Typography>
                            <Grid item>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Avatar
                                            src={avatar}
                                            sx={{ width: 90, height: 90 }}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Typography sx={{ color: globals.colors.gray, fontSize: 12, mx: 2, mt: 2 }}>JPG или PNG</Typography>
                                        <Button variant='contained' component='label' size={'small'} sx={{
                                            backgroundColor: globals.colors.lightRed, textTransform: 'none', '&:hover': {
                                                backgroundColor: globals.colors.darkRed
                                            },
                                        }}>
                                            Смени снимката
                                            <input
                                                type="file"
                                                accept="image/*"
                                                hidden
                                                onChange={handleImageChange}
                                            />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container sx={{ mt: 0 }} spacing={5}>
                                <Grid item sm={6}>
                                    <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Username</Typography>
                                    <DashboardTextField disabled label={`@${user.username}`} fullWidth />
                                </Grid>
                                <Grid item sm={6}>
                                    <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>E-Mail</Typography>
                                    <DashboardTextField defaultValue={user.email} fullWidth id="email" onChange={handleUserDataChange} />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mt: 0 }} spacing={5}>
                            <Grid item sm={6}>
                                <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Име</Typography>
                                <DashboardTextField fullWidth value={userData.first_name} id="first_name" onChange={handleUserDataChange} />
                            </Grid>
                            <Grid item sm={6}>
                                <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Фамилия</Typography>
                                <DashboardTextField fullWidth value={userData.last_name} id="last_name" onChange={handleUserDataChange} />
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mt: 0 }} spacing={5}>
                            <Grid item sm={6}>
                                <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Смени парола</Typography>
                                <DashboardTextField fullWidth
                                    type="password"
                                    id="password"
                                    value={userData.password}
                                    onChange={handleUserDataChange} />
                            </Grid>
                            <Grid item sm={6}>
                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', }}>Повтори паролата</Typography>
                                <DashboardTextField fullWidth
                                    sx={{ mt: 1 }}
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    error={confirmPassword.length > 0 && confirmPassword !== userData.password}
                                    helperText={
                                        confirmPassword.length > 0 && confirmPassword !== userData.password
                                            ? "Паролите не съвпадат"
                                            : ""
                                    } />
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mt: 0 }} spacing={5}>
                            <Grid item sm={6}>
                                <Typography sx={{ mb: 1, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Телефонен номер</Typography>
                                <DashboardTextField fullWidth value={userData.phone_number} id="phone_number" onChange={handleUserDataChange} />
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item>
                                <Button variant='contained' onClick={handleSaveChanges} type='submit' size='large' sx={{
                                    mt: 3, px: 5, backgroundColor: globals.colors.lightRed, textTransform: 'none', '&:hover': {
                                        backgroundColor: globals.colors.darkRed,
                                    },
                                }}> Запази промените</Button>
                            </Grid>
                        </Grid>
                    </TabPanel>

                    <TabPanel value={tabValue} index={4}>
                        <Grid container spacing={2}>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 17 }}>Правила за ученици в eAcademiaBg:</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>1. Ако няма да присъстваш на урок, трябва да ни уведомиш поне 24 часа предварително.</strong> При спешни случаи – до 3 часа преди урока. В противен случай урокът се счита за проведен и се таксува.</Typography>
                            </Grid>

                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>2. При неявяване без предупреждение</strong>, урокът се счита за проведен.</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>3. Ако урокът не се проведе по вина на учителя</strong>, ще получиш компенсаторен урок безплатно.</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>4. Домашните не са по избор.</strong> Важно е и за учителя и за теб да се упражняваш.</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>5. Присъствието в уроците е през платформата на eAcademiaBg.</strong> Използването на други канали за провеждане на уроци не е позволено.</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>6. Поддържай активна комуникация.</strong> Следи профила си и съобщенията от екипа и учителите.</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>7.</strong> Уроците са и място за развлечение. <strong>Но, по време на урок е нужно пълно внимание и съсредоточеност.</strong></Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>8. Общуваме с уважение.</strong> Грубост, обиди или неподходящо поведение към учители, съученици или екипа не се допускат</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>9. Уроците се записват, за да следим за качество. </strong> Достъп до записите има само екипът на eAcademiaBg и ти (твоите родители) при нужда.</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>10. Не обменяй лични контакти с учителя. </strong>Всички уроци и комуникация се осъществяват през платформата.</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>11. При проблем или въпрос – обърни се към нас.</strong> На среща сме, за да помагаме.</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ color: globals.colors.darkBlue, fontSize: 13 }}><strong>12. При регистрацията ти в платформата се съгласяваш с тези условия.</strong></Typography>
                            </Grid>
                        </Grid>
                    </TabPanel>
                </Grid>

                {/* Notifications Section */}
                <Grid
                    item
                    xs={12}
                    sm={3}
                    justifyContent={"center"}
                    textAlign={"center"}
                    alignItems={"center"}
                >
                    <Paper elevation={2}>
                        <Typography>
                            <NotificationsNoneIcon sx={{ mr: 0.5, mb: -0.5 }} />
                            Известия
                        </Typography>

                        <Grid container spacing={2} sx={{ mt: 0.5 }}>
                            {notifications.map(notification => (
                                <Grid item>
                                    <a href={notification.url_path} style={{ textDecoration: 'none' }}>
                                        <Paper sx={{ p: 2, backgroundColor: globals.colors.backgroundColor }} elevation={4}>
                                            <Typography sx={{
                                                color: globals.colors.textColor, fontWeight: 'bold'
                                            }}>{notification.content}</Typography>
                                            <Typography sx={{ mt: 1, fontSize: 13, color: globals.colors.textColor }}>{notification.time} {notification.date}</Typography>
                                        </Paper>
                                    </a>
                                </Grid>
                            ))}
                        </Grid>
                    </Paper>
                </Grid>
            </Grid >

            <Grid container>
                <Paper sx={{ mt: 2, px: 7, py: 1 }}>
                    <Grid container alignItems={'center'} spacing={4} justifyContent={'center'} textAlign={'center'}>
                        <Grid item>
                            <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>
                                <HelpOutlineIcon sx={{ fontSize: 30, mb: -0.9, mr: 2 }} />
                                Ако ти трябва помощ с профила ти:</Typography>
                        </Grid>
                        <Grid item>
                            <RedButton text={'Свържи се с нас'} mTop={0} pX={5} href={'/contact-us'} />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Container >
    );
}

export default StudentDashboard;